import localforage from 'localforage';
import { StorageFullError } from '@/lib/errorUtils';

export const getResumesKey = (workspaceId: string) => `resumeChecker_resumes_${workspaceId}`;
export const getOutputsKey = (workspaceId: string) => `resumeChecker_outputs_${workspaceId}`;

export const getLocalItem = async <T>(key: string, defaultValue: T): Promise<T> => {
  try {
    const item = await localforage.getItem<T>(key);
    return item ?? defaultValue;
  } catch (e) {
    return defaultValue;
  }
};

export const setLocalItem = async (key: string, value: any) => {
  try {
    await localforage.setItem(key, value);
  } catch (e: any) {
    if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
      throw new StorageFullError();
    }
    throw e;
  }
};

export const clearAll = async (): Promise<void> => {
  await localforage.clear();
};
